export default __webpack_public_path__ + "static/media/p3.8ddba762.jpg";